import {
  Box,
  Grid,
  Heading,
  HStack,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { FiBook } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const BooksIntro = () => {
  const { t } = useTranslation();
  const panelBg = useColorModeValue(
    "linear(to-b, white, gray.50)",
    "linear(to-b, gray.800, gray.900)",
  );
  const softText = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.200", "gray.600");

  return (
    <Box
      id="books-intro"
      borderRadius="2xl"
      bgGradient={panelBg}
      boxShadow="xl"
      overflow="hidden"
    >
      <VStack id="books-intro-sections" align="stretch" spacing={0}>
        <VStack
          id="books-intro-hero"
          boxSizing="border-box"
          flexShrink={0}
          px={{ base: 5, md: 10 }}
          py={{ base: 8, md: 10 }}
          spacing={4}
          justify="center"
          textAlign="center"
        >
          <Heading id="books-intro-hero-title" size={{ base: "lg", md: "xl" }}>
            {t("books.introHeroTitle", "Create and manage your books")}
          </Heading>
          <Text
            id="books-intro-hero-body"
            maxW="2xl"
            color={softText}
            fontSize={{ base: "md", md: "lg" }}
          >
            {t(
              "books.introHeroBody",
              "Publish your work to the library, or start a new book. Manage drafts and published titles in one place.",
            )}
          </Text>
        </VStack>

        <VStack
          id="books-intro-actions"
          px={{ base: 5, md: 10 }}
          pb={{ base: 8, md: 10 }}
          spacing={4}
          align="stretch"
        >
          <Text
            id="books-intro-actions-title"
            fontSize="sm"
            fontWeight="semibold"
            color={softText}
            textAlign="center"
          >
            {t("books.introActionsTitle", "What you can do")}
          </Text>
          <Grid
            id="books-intro-actions-grid"
            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
            gap={4}
            w="100%"
            maxW="3xl"
            mx="auto"
          >
            <Box
              id="books-intro-action-my-books"
              p={5}
              borderRadius="md"
              bg={cardBg}
              borderWidth="1px"
              borderColor={cardBorder}
              boxShadow="sm"
            >
              <VStack align="stretch" spacing={2} textAlign="left">
                <HStack spacing={2}>
                  <Icon
                    as={FiBook as React.ElementType}
                    id="books-intro-action-my-books-icon"
                    boxSize={5}
                  />
                  <Heading id="books-intro-action-my-books-title" size="sm">
                    {t("menu.myBooks")}
                  </Heading>
                </HStack>
                <Text
                  id="books-intro-action-my-books-description"
                  fontSize="sm"
                  color={softText}
                >
                  {t(
                    "books.introActionMyBooksDesc",
                    "View and manage your published books and drafts in one place.",
                  )}
                </Text>
              </VStack>
            </Box>
            <Box
              id="books-intro-action-create-book"
              p={5}
              borderRadius="md"
              bg={cardBg}
              borderWidth="1px"
              borderColor={cardBorder}
              boxShadow="sm"
            >
              <VStack align="stretch" spacing={2} textAlign="left">
                <HStack spacing={2}>
                  <AddIcon
                    id="books-intro-action-create-book-icon"
                    boxSize={5}
                  />
                  <Heading id="books-intro-action-create-book-title" size="sm">
                    {t("menu.createBook")}
                  </Heading>
                </HStack>
                <Text
                  id="books-intro-action-create-book-description"
                  fontSize="sm"
                  color={softText}
                >
                  {t(
                    "books.introActionCreateBookDesc",
                    "Start a new book: add chapters, upload content, and publish to the library.",
                  )}
                </Text>
              </VStack>
            </Box>
          </Grid>
        </VStack>
      </VStack>
    </Box>
  );
};

export default BooksIntro;
